import PopoverTooltip from "../PopoverTooltip";
import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import {PROCESS_QUESTION_TEXT, PROCESS_TEXT_LAYOUT} from "../../scripts/layout-manager";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import QuestionFootnote from "./QuestionFootnote";

export default function QuestionText(props) {
  const {question, questionClass = '', textClass = ''} = props;
  let questionClassName = `page-question-text ${questionClass} ${PROCESS_TEXT_LAYOUT(question)} pl-0 pr-3`;
  let questionText = PROCESS_QUESTION_TEXT(question)

  return (
    <Col className={questionClassName}>
      <Container className={`p-0`}>
        <Row className={textClass}>
          {question.label?.icon && (
            <Col className={'p-0'} style={{flexGrow: 0}}>
              <FontAwesomeIcon icon={question.label?.icon} className={'label-icon'}/>
            </Col>
          )}
          <Col className={'p-0'}>
            {questionText}
            {
              question.info && (
                <>
                  &nbsp;
                  <PopoverTooltip
                    title={question.info.title}
                    content={question.info.content} />
                </>
              )
            }
          </Col>
        </Row>
        {question.footnote?.placement === 'Label' && (
          <Row className={textClass}>
            <Col className={'p-0'}>
              <QuestionFootnote question={question}/>
            </Col>
          </Row>
        )}
      </Container>
    </Col>
  )
}